import { useState, useRef, useEffect } from 'react';
import '../styles/ExportVote.css';
import '../styles/BaseForm.css';
import '../styles/WaitingRoom.css';

import fr from '../locales/fr';
import en from '../locales/en';

import { useNavigate, useLocation, Navigate } from 'react-router-dom';

import image1 from '../img/prop1.png';
import image2 from '../img/prop2.png';
import image3 from '../img/prop3.png';
import image4 from '../img/prop4.png';
import image5 from '../img/prop5.png';
import image6 from '../img/prop6.png';
import image7 from '../img/prop7.png';
import image8 from '../img/prop8.png';
import image9 from '../img/prop9.png';
import image10 from '../img/prop10.png';
import image11 from '../img/prop11.png';
import image12 from '../img/prop12.png';
import image13 from '../img/prop13.png';
import image14 from '../img/prop14.png';
import image15 from '../img/prop15.png';
import image16 from '../img/prop16.png';
import image17 from '../img/prop17.png';
import image18 from '../img/prop18.png';

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

const setCookie = (name, value, minutes = 120) => {
    const expires = new Date(Date.now() + minutes * 60000).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};

const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

function Ready({ ws }) {
    const navigate = useNavigate();
    const location = useLocation();

    const browserLang = navigator.language || navigator.userLanguage;
    const language = browserLang.startsWith('fr') ? 'fr' : 'en';
    const translations = language === 'fr' ? fr : en;

    const allowed =
        location.state?.fromAuthorized ||
        sessionStorage.getItem('canAccessReady');

    const savedRole = getCookie('playerRole');
    const [role, setRole] = useState(savedRole || null);
    const [countdown, setCountdown] = useState(null);

    const intervalRef = useRef(null);
    const roleRef = useRef(savedRole || null);

    useEffect(() => {
        if (allowed) {
            sessionStorage.removeItem('canAccessReady');
        }
    }, [allowed]);

    useEffect(() => {
        if (!ws) return;
        const handleWebSocketMessage = (event) => {
            const msg = event.data;
            const ROOM = localStorage.getItem('UNITY');

            if (msg === ROOM + ':WAIT') {
                roleRef.current = 'waiting';
                setCookie('playerRole', 'waiting');
                setRole('waiting');
            } else if (msg === ROOM + ':STARTER') {
                roleRef.current = 'starter';
                setCookie('playerRole', 'starter');
                setRole('starter');
            } else if (msg === ROOM + ':GO') {
                if (roleRef.current === 'starter') {
                    setCookie('playerRole', 'go');
                    setRole('go');
                }
            }
        };

        const handleTransitionEnd = (event) => {
            const container = document.querySelector('.container');
            const image = event.target;

            if (container && container.contains(image)) {
                container.removeChild(image);
            }
        };

        const generateImages = () => {
            const numberOfImages = 5;
            const container = document.querySelector('.container');

            if (!container) return;

            const images = [
                image1, image2, image3, image4, image5, image6,
                image7, image8, image9, image10, image11, image12,
                image13, image14, image15, image16, image17, image18
            ];

            for (let i = 0; i < numberOfImages; i++) {
                const image = document.createElement('img');

                const randomImageIndex = Math.floor(Math.random() * images.length);
                const randomSize = Math.random() * 50 + 30;
                const randomX = Math.random() * (window.innerWidth - randomSize);
                const randomAnimationDuration = Math.random() * 5 + 2;

                image.setAttribute('src', images[randomImageIndex]);

                image.classList.add('rain-image');

                image.style.width = `${randomSize}px`;
                image.style.position = 'absolute';
                image.style.left = `${randomX}px`;
                image.style.top = `-${randomSize}px`;
                image.style.animationDuration = `${randomAnimationDuration}s`;
                image.style.transition = `top ${randomAnimationDuration}s linear`;

                container.appendChild(image);

                setTimeout(() => {
                    image.style.top = `${window.innerHeight}px`;
                }, 0);
            }
        };

        const container = document.querySelector('.container');

        if (container) {
            container.addEventListener('transitionend', handleTransitionEnd);
        }

        ws.addEventListener('message', handleWebSocketMessage);

        generateImages();

        const interval = setInterval(generateImages, 2500);

        return () => {
            clearInterval(interval);

            if (container) {
                container.removeEventListener('transitionend', handleTransitionEnd);
            }

            ws.removeEventListener('message', handleWebSocketMessage);
        };
    }, [ws]);

    const handleStart = () => {
        setCountdown(5);

        let remaining = 5;

        intervalRef.current = setInterval(() => {
            remaining -= 1;

            if (remaining <= 0) {
                clearInterval(intervalRef.current);

                intervalRef.current = null;

                setCountdown(null);

                const ROOM = localStorage.getItem('UNITY');

                ws.send(ROOM + ":RDY");

                deleteCookie('playerRole');
                sessionStorage.setItem('canAccessWaitingState', 'true');

                navigate("/waitingState", {
                    state: { fromAuthorized: true }
                });
            } else {
                setCountdown(remaining);
            }
        }, 1000);
    };

    const handleCancel = () => {
        clearInterval(intervalRef.current);

        intervalRef.current = null;

        setCountdown(null);
    };

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    const isCounting = countdown !== null;

    if (role === 'waiting') {
        deleteCookie('playerRole');
        sessionStorage.setItem('canAccessWaitingState', 'true');
        return <Navigate to="/waitingState" state={{ fromAuthorized: true }} replace />;
    }

    if (role === 'starter') {
        return (
            <div className="container">
                <h1 className="title">
                    {translations.waitingState.title}
                    <span className="dots"></span>
                </h1>

                <div className="loader"></div>
            </div>
        );
    }

    if (role === 'go') {
        return (
            <div className="boxform">
                <h1 className="title">
                    {translations.ready.title}
                </h1>

                <button
                    className="submit-button"
                    onClick={isCounting ? handleCancel : handleStart}
                    style={
                        isCounting
                            ? {
                                  background:
                                      'linear-gradient(135deg, #ff4444 0%, #cc0000 100%)'
                              }
                            : undefined
                    }
                >
                    {isCounting
                        ? `${translations.ready.cancel} (${countdown})`
                        : translations.ready.button}
                </button>
            </div>
        );
    }

    return <div className="boxform" />;
}

export default Ready;
